import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import DentalHero from '../components/DentalLanding/DentalHero'
import SocialProof from '../components/DentalLanding/SocialProof'
import CampaignStrategy from '../components/DentalLanding/CampaignStrategy'
import WhyOLM from '../components/DentalLanding/WhyOLM'
import HowItWorks from '../components/DentalLanding/HowItWorks'
import FAQ from '../components/DentalLanding/FAQ'
import BookingSection from '../components/DentalLanding/BookingSection'
import Footer from '../components/Footer'

export default function Dental({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header meta={data?.yoast_head} />
            <DentalHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />
            <Footer />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .dental-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .dental-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .dental-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/dental')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
